module.exports = __webpack_public_path__ + "static/media/function.eadd2007.png";